import { postRequest } from 'utils/http';
import { UpdateUserChannelsRequest } from './types';

export async function updateUserChannelsAPI(data: UpdateUserChannelsRequest) {
    const url = `/tv-channels/submit?subscriptionId=${data.subscriptionId}&externalProductId=${data.externalProductId}&ts=${data.ts}&code=${encodeURIComponent(data.code)}`;

    return postRequest<void>(url, data.channels);
}
